import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import scrollToElement from "helpers/scroll-to-element"
import useWindowDimensions from "helpers/window-dimensions"

export const H1 = styled(Typography).attrs({
  as: "h1",
  color: "black",
  mb: { _: 2, tablet: 4 },
  mt: 0,
})`
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
`

export const H2 = styled(Typography).attrs({
  as: "h2",
  color: "black",
  mb: { _: 2, tablet: 4 },
  mt: 0,
})`
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
`

export const H3 = styled(Typography).attrs({
  as: "h3",
  color: "black",
  mb: { _: 2, tablet: 4 },
  mt: 0,
})`
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
`

export const P = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
`

export const Li = styled(P).attrs({
  as: "li",
})`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`
export const Strong = styled.strong`
  font-weight: 700;
`

export const A = styled(Link).attrs((props) => ({
  ...props,
}))`
  text-decoration: underline;

  &:focus,
  &:hover {
    text-decoration: none;
  }
`

const AnchorLink = ({ href, ...props }) => {
  const { isLarge } = useWindowDimensions()

  return (
    <A
      as="a"
      href={href}
      onClick={(e) => {
        e.preventDefault()
        scrollToElement(href, isLarge ? 210 : 160)
      }}
      {...props}
    />
  )
}

AnchorLink.propTypes = {
  href: PropTypes.string,
}

export const components = {
  a: ({ href, ...props }) =>
    href?.startsWith("http") ? (
      <A as="a" href={href} target="_blank" {...props} />
    ) : href?.startsWith("#") ? (
      <AnchorLink href={href} {...props} />
    ) : (
      <A target="_blank" to={href} {...props} />
    ),
  h1: H1,
  h2: H2,
  h3: H3,
  li: Li,
  p: P,
  strong: Strong,
}
